module.exports = __webpack_public_path__ + "static/img/timestream.731db158.png";